import React, { ReactNode } from 'react';
import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from 'api/fetchApi';
import { observer } from 'mobx-react';
import { mobxStore } from 'store/mobx';
import { isSignedIn } from 'utils/userPermissions';

type LiveChatState = {
  isScriptLoadingFinished: boolean;
  token: string;
};

class HubSpotLiveChat extends React.Component<object, LiveChatState> {
  timeout = 3000;

  state: LiveChatState = {
    isScriptLoadingFinished: false,
    token: '',
  };

  mobxAccountStore = mobxStore.accountStore;

  async componentDidMount(): Promise<void> {
    const { generalSettings, initialUserInfo: user } = this.mobxAccountStore;
    const { isScriptLoadingFinished } = this.state;
    const { hubSpotLiveChat } = generalSettings;

    if (!hubSpotLiveChat || !hubSpotLiveChat.enabled || !hubSpotLiveChat.scriptUrl) {
      return;
    }

    if (isScriptLoadingFinished) {
      return;
    }

    setTimeout(() => {
      const script = document.createElement('script');

      script.setAttribute('id', 'hs-script-loader');
      script.src = hubSpotLiveChat.scriptUrl;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      this.setState({ isScriptLoadingFinished: true });
    }, this.timeout);

    if (hubSpotLiveChat.userAuthentication && isSignedIn(user)) {
      await fetchApi.get<string>(ApiUrls.hubSpot.getToken).then((response) => {
        this.setState({ token: response.data });
      });
    }
  }

  componentDidUpdate(): void {
    const { isScriptLoadingFinished, token } = this.state;
    const { initialUserInfo: user } = this.mobxAccountStore;

    if (!isScriptLoadingFinished || !user) {
      return;
    }

    if (token) {
      window.hsConversationsSettings = {
        identificationEmail: user.email,
        identificationToken: token,
      };

      if (window.HubSpotConversations) {
        this.onConversationsAPIReady();
      } else {
        window.hsConversationsOnReady = [this.onConversationsAPIReady];
      }
    }
  }

  onConversationsAPIReady(): void {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.load();
    }
  }

  render(): ReactNode {
    return null;
  }
}

export default observer(HubSpotLiveChat);
